import React from 'react';
import Spinner from './Spinner';

/**
 * Full-viewport blurred overlay with centered spinner.
 * Also used by ApiLoadingProvider for all in-flight API requests.
 */
function LoadingOverlay({ show = false, message = 'Loading…', className = '' }) {
  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/25 backdrop-blur-[6px] px-4 ${className}`}
      aria-busy="true"
      aria-live="polite"
      aria-label={message}
    >
      <div className="flex flex-col items-center gap-4 rounded-2xl border border-white/70 bg-white/85 px-10 py-8 shadow-[0_20px_50px_-12px_rgba(15,23,42,0.35)] backdrop-blur-md">
        <Spinner size="lg" label={message} />
        {message ? (
          <p className="text-sm font-semibold tracking-wide text-slate-700">{message}</p>
        ) : null}
      </div>
    </div>
  );
}

export default LoadingOverlay;
